<template>
    <TooltipProvider
        disable-closing-trigger
        disable-hoverable-content
        :delay-duration="300">
        <TooltipRoot>
            <TooltipTrigger>
                <slot />
            </TooltipTrigger>
            <TooltipPortal>
                <TooltipContent
                    side="bottom"
                    :side-offset="-5"
                    :class="[...openAnimation, ...closeAnimation]"
                    class="z-50 select-none rounded-4 bg-ash-45/80 p-2 text-12/100 font-semibold text-ash backdrop-blur-sm transition-all duration-300">
                    {{ text }}
                    <TooltipArrow
                        :width="10"
                        :height="7"
                        class="fill-ash-45/80 stroke-ash-45/80" />
                </TooltipContent>
            </TooltipPortal>
        </TooltipRoot>
    </TooltipProvider>
</template>

<script setup lang="ts">
import {
    TooltipArrow,
    TooltipContent,
    TooltipPortal,
    TooltipProvider,
    TooltipRoot,
    TooltipTrigger,
} from 'reka-ui'

defineProps({
    text: {
        type: String as PropType<string>,
        required: true,
    },
})

const openAnimation = [
    'data-[state="delayed-open"]:data-[side="top"]:animate-openFromDown',
    'data-[state="delayed-open"]:data-[side=right]:animate-openFromLeft',
    'data-[state="delayed-open"]:data-[side="left"]:animate-openFromRight',
    'data-[state="delayed-open"]:data-[side="bottom"]:animate-openFromUp',
]

const closeAnimation = [
    'data-[state="closed"]:data-[side="top"]:animate-closeFromDown',
    'data-[state="closed"]:data-[side=right]:animate-closeFromLeft',
    'data-[state="closed"]:data-[side="left"]:animate-closeFromRight',
    'data-[state="closed"]:data-[side="bottom"]:animate-closeFromUp',
]
</script>
